import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { store, persistor, useAppDispatch, useAppSelector } from './store';
import { sessionExpired, fetchMeThunk } from './store/slices/auth.slice';
import { configureApiAuth } from './services/api/base-api';
import { AppThemeProvider } from './theme/theme-provider';
import { GlobalStyles } from './theme/global-styles';
import { AppRoutes } from './routes/app-routes';
import { useTheme } from './hooks/use-theme';
import { themes } from './theme/theme';

const ApiBootstrap = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.accessToken);
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    configureApiAuth(
      () => store.getState().auth.accessToken,
      () => store.dispatch(sessionExpired()),
    );
  }, []);

  useEffect(() => {
    if (token && isLoggedIn) {
      dispatch(fetchMeThunk());
    }
  }, [token, isLoggedIn, dispatch]);

  return null;
};

const ThemedToaster = () => {
  const { effectiveMode } = useTheme();
  const theme = themes[effectiveMode];
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          fontFamily: theme.font.secondary,
          fontSize: 14,
          background: theme.colors.bgSurfaceElevated,
          color: theme.colors.textPrimary,
          border: `1px solid ${theme.colors.border}`,
        },
      }}
    />
  );
};

const App = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <AppThemeProvider>
        <GlobalStyles />
        <BrowserRouter>
          <ApiBootstrap />
          <AppRoutes />
          <ThemedToaster />
        </BrowserRouter>
      </AppThemeProvider>
    </PersistGate>
  </Provider>
);

export default App;
